import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "navigation-context"

  static values = {
    context: String,
    isAdmin: Boolean
  }

  connect() {
    super.connect()
    this.send("connect", {
      context: this.contextValue,
      is_admin: this.isAdminValue
    })
  }
}
